import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { ApiError, allApplicationsKey } from "./useGetAllApplications";

const jsonHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
};

type DeleteApplicationOptions = {
    id: string;
};

export const useDeleteApplication = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation<void, ApiError, DeleteApplicationOptions>(
        async (options: DeleteApplicationOptions) => {
            const { id } = options;
            await loggedInApiCall.delete(`/api/integrations/applications/${id}`, {
                headers: jsonHeaders,
            });
        },
        {
            onSuccess: (_, { id }) => {
                queryClient.removeQueries(["getOneApplication", id]);
                queryClient.invalidateQueries(allApplicationsKey);
            },
            onError: (error: ApiError) => {
                return Promise.reject(new Error("Failed to delete application"));
            },
        },
    );

    return mutation;
};
